module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/stride-17273ac4223d1ac2cabaef489c57d566.png";